import React, { Component } from "react";
import styled, { withTheme } from "styled-components";
import { ocean } from "@vitalsource/vstui/colors";
import { Dialog, TextField } from "@vitalsource/vstui";
import { Translation, t } from "../../../core/translate";
import { connect } from "react-redux";
import { actions as modalActions } from "../../../../redux/modals";
import { selectors as brandSelectors } from "../../../../redux/brand";
import { selectors as userSelectors } from "../../../../redux/user";

const CommentTypes = styled.fieldset`
  border: none;
`;

const CheckboxItem = styled.li`
  display: inline-flex;
  margin-left: 4px;
  padding-bottom: 6px;
  input[type="checkbox"]:focus + label {
    border: 1px solid ${ocean.getShade(8)};
  }
  label {
    background-color: ${props => props.theme.color.primary.getShade(1)};
    border: 1px solid ${props => props.theme.color.primary.getShade(2)};
    border-radius: 26.5px;
    padding: 7px 12px;
    cursor: pointer;
    &.checked {
      background-color: ${props => props.theme.color.primary.getShade(2)};
      border-color: ${props => props.theme.color.primary.getShade(3)};
    }
  }
`;
const Checkboxes = styled.ul`
  margin-right: -4px;
`;
const Checkbox = ({ checked, labelText, id, onChange }) => (
  <CheckboxItem>
    <input
      id={id}
      className="no-checkbox"
      checked={checked}
      onChange={onChange}
      type="checkbox"
      value={id}
    />
    <label htmlFor={id} className={checked ? "checked" : "unchecked"}>
      <Translation id={labelText}>{id}</Translation>
    </label>
  </CheckboxItem>
);

const checkboxLabels = [
  { key: "performance", fallback: "Performance" },
  { key: "sign-in", fallback: "Sign in" },
  { key: "accessibility", fallback: "Accessibility" },
  { key: "content-error", fallback: "Content Error" },
  { key: "search", fallback: "Search" },
  { key: "toc", fallback: "Table of Contents" },
  { key: "printing", fallback: "Printing" },
  { key: "page-nav", fallback: "Page Navigation" },
  { key: "zoom", fallback: "Zoom" },
  { key: "syncing", fallback: "Syncing" },
  { key: "other", fallback: "Other" }
];

class Feedback extends Component {
  constructor() {
    super();
    const defaultState = checkboxLabels.reduce((acc, label) => {
      acc[label.key] = false;
      return acc;
    }, {});

    this.state = defaultState;

    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleFeedbackChange = this.handleFeedbackChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  handleFeedbackChange(e) {
    const { value } = e.currentTarget;
    this.setState({
      feedback: value
    });
  }

  handleCheckboxChange(e) {
    const key = e.currentTarget.value;
    this.setState(prevState => ({
      [key]: !prevState[key]
    }));
  }

  onSubmit(e) {
    e.preventDefault();
    const relatedTo = checkboxLabels.reduce((acc, label) => {
      if (this.state[label.key]) {
        acc.push(`entry.346467051=${encodeURIComponent(label.fallback)}`);
      }
      return acc;
    }, []);

    $.ajax({
      url:
        "https://docs.google.com/forms/d/e/1FAIpQLSdwBwFbKnhil6F6floyQaycHOBO2Z2HuRhNcUanDb77A9U8xA/formResponse",
      type: "POST",
      data:
        `entry.1192857534=${encodeURIComponent(navigator.userAgent)}&` +
        `entry.1430982976=${encodeURIComponent(this.props.brandName)}&` +
        "entry.346467051_sentinel&" +
        relatedTo.join("&") +
        "&entry.616240389=" +
        encodeURIComponent(this.state.feedback) +
        `&entry.1714889103=${encodeURIComponent(this.props.userId)}`
    });
    this.props.closeModal();
  }

  render() {
    const { closeModal, brandName } = this.props;
    return (
      <Dialog
        open
        darkHeader
        key="FeedbackModal"
        rootSelector="#bookshelf"
        size="large"
        onRequestClose={closeModal}
        title={t("feedback.help-improve-2", "Help us improve Bookshelf!", {
          brandName: brandName
        })}
        formProps={{ onSubmit: this.onSubmit }}
        primaryActionButton={{ label: t("base.submit", "Submit") }}
        secondaryActionButton={{
          label: t("base.cancel", "Cancel"),
          onClick: closeModal
        }}
      >
        <div className="legacy-checkboxes">
          <TextField
            fullWidth
            label={t("feedback.feedback", "Feedback")}
            multiline
            required
            rows={5}
            name="feedback"
            onChange={this.handleFeedbackChange}
          />
          <CommentTypes>
            <legend>
              <Translation id="feedback.relates-to">
                This comment relates to (choose at least one):
              </Translation>
            </legend>
            <Checkboxes>
              {checkboxLabels.map(({ key }) => (
                <Checkbox
                  key={key}
                  checked={this.state[key]}
                  labelText={`feedback.types.${key}`}
                  id={key}
                  name={key}
                  onChange={this.handleCheckboxChange}
                />
              ))}
            </Checkboxes>
          </CommentTypes>
        </div>
      </Dialog>
    );
  }
}

const mapStateToProps = (state, props) => ({
  brandName: brandSelectors.getBrandValue(state, "brand"),
  userId: userSelectors.getUser(state).identifier
});

const mapDispatchToProps = (dispatch, props) => ({
  closeModal: () => dispatch(modalActions.closeModal())
});

export default withTheme(
  connect(mapStateToProps, mapDispatchToProps)(Feedback)
);
